import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api, req } from '@/lib/api/client';
import { keys } from '@/lib/api/keys';
import { isApiError } from '@/lib/api/errors';
import { Button } from '@/components/Button';
import { Input, Label } from '@/components/Input';
import { AuthShell } from '@/features/auth/AuthShell';

export function CreateWorkspacePage() {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const qc = useQueryClient();
  const auto = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  async function submit(e: FormEvent) {
    e.preventDefault();
    try {
      const ws = await req(api.POST('/workspaces', { body: { name, slug: slug || auto } }));
      await qc.invalidateQueries({ queryKey: keys.me() });
      navigate(`/w/${ws.slug}`, { replace: true });
    } catch (err) {
      setError(isApiError(err) ? err.message : 'Could not create workspace');
    }
  }
  return (
    <AuthShell title="Create a workspace" subtitle="A workspace holds your libraries, boards and team.">
      <form onSubmit={submit} className="space-y-3">
        <div>
          <Label htmlFor="ws-name">Name</Label>
          <Input id="ws-name" required value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <Label htmlFor="ws-slug">URL slug</Label>
          <Input id="ws-slug" value={slug} placeholder={auto} onChange={(e) => setSlug(e.target.value)} pattern="[a-z0-9\-]{2,}" />
        </div>
        {error && (
          <p className="text-sm text-danger" role="alert">
            {error}
          </p>
        )}
        <Button type="submit" variant="primary" className="w-full">
          Create workspace
        </Button>
      </form>
    </AuthShell>
  );
}
